import { render } from "./emoji-picker.vue?vue&type=template&id=02e6d63a"
import script from "./emoji-picker.vue?vue&type=script&lang=js"
export * from "./emoji-picker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__